import { Box, Typography } from "@mui/material";

import feedbackImage from "../../../../assets/img/feedback.png";

export const FeedbackSubmittedScreen = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "20px"
      }}
    >
      <img
        src={feedbackImage}
        alt="Expired Link"
        style={{ height: "300px", width: "320px" }}
      />
      <Typography variant="h4" style={{ paddingTop: "10px" }}>
        Thanks for submitting feedback to your Verification Agency!
      </Typography>
      <Typography variant="body2" color="secondary" style={{ paddingTop: "10px", textAlign: 'center' }}>
        We'd appreciate it if you took a moment to give us feedback on your experience <br />
        with the <i>BEE123 Software</i>. Feel free to send us an email on <br />
        <a href="mailto:SoftwareFeedback@bee123.co.za">SoftwareFeedback@bee123.co.za</a>
      </Typography>
    </Box>
  );
}